import React from 'react';
import { BrowserRouter, Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import './App.css';
import './System/styles/viewLayout.css';
import './AntCss.css';
import MainLayout from './System/Layout/MainLayout';
import { GlobalProvider, useGlobal } from './System/Global/GlobalProvider';
import LoginPage from './Components/Authentication/Login';
import { Addresses } from './Components/OPS/Addresses';
import { Bookings } from './Components/OPS/Bookings';
import { BookingNew } from './Components/OPS/BookingNew';
import { BookingDraftView } from './Components/OPS/BookingDraftView';
import { BookingView } from './Components/OPS/BookingView';
import QuickQuote from './Components/OPS/Quote/QuickQuote';


function App() {
  return (
      <>
        <GlobalProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/*" element={<MainLayoutWithRoutes />} />
                </Routes>
            </BrowserRouter>
        </GlobalProvider>
      </>
  );
}

function MainLayoutWithRoutes() {
	

	const { checkAuth } = useGlobal();
	const navigate = useNavigate();

	if (!checkAuth()) { navigate('/login') } 

	return (
		checkAuth() ?
			
			<MainLayout>
				<Routes>
					<Route path="/" element={<Navigate to="/bookings/Delivered" replace />} />
					<Route path="/quote" element={<QuickQuote />} />
					<Route path="/addresses" element={<Addresses />} />
					<Route path="/bookings/new" element={<BookingNew />} />
					<Route path="/bookings/view/:bookingKey" element={<BookingView />} />
					<Route path="/bookings/draft/view/:bookingKey" element={<BookingDraftView />} />
					<Route path="/bookings/:status" element={<Bookings />} />
					
					<Route path="*" element={<Bookings />} />
				</Routes>
			</MainLayout>

			
		: 
			<Routes>
				<Route path="/*" element={<LoginPage />} />
			</Routes>
	);
}

export default App;
